// This class should provide different browser compatibility checks
// supportsNativeExif: Checks if browser natively respects EXIF orientation when loading an image
// For now only for Chrome 81+ supports this but other browsers will follow
// Sources: https://paul.kinlan.me/correct-image-orientation-for-images-chrome-81/
// https://www.fxsitecompat.dev/en-CA/docs/2020/jpeg-images-are-now-rotated-by-default-according-to-exif-data/
// Firefox and Safari will support in the "near future"

export default class BrowserCompatibility {
    static getChromeVersion(userAgent) {
        var pieces = userAgent.match(/Chrom(?:e|ium)\/([0-9]+)\.([0-9]+)\.([0-9]+)\.([0-9]+)/);
        if (pieces == null || pieces.length != 5) {
            return undefined;
        }
        pieces = pieces.map(piece => parseInt(piece, 10));
        return {
            major: pieces[1],
            minor: pieces[2],
            build: pieces[3],
            patch: pieces[4]
        };
    }

    static supportsNativeExif(userAgent) {
        var chromeVersion = this.getChromeVersion(userAgent);
        if (chromeVersion) {
            return chromeVersion.major >= 81;
        }
        return false;
    }
}